<!--
  Structural Component for a simple HTML Element only serving the semantic
  purpose to add some classes in it

  Hence the name:

  > *Wad* (noun): a small mass, lump, or ball of anything ; a roll of something
-->
<template>
  <div class="ui-wad">
    <slot />
  </div>
</template>
